import React from 'react'
import { Image } from '@ta-interaktiv/contentbricks'

import './styles.scss'
export interface Props {
  type: string
  content: [number, string]
}
const numberFormat = (n: number) => {
  return new Intl.NumberFormat('ch-DE').format(n)
}
export const CardFront = ({ type, content }: Props) => {
  switch (type) {
    case 'trees':
      return (
        <>
          <div className='vizText'>
            <Image file={require('images/_illus_trees.svg')} />
            <div className='vizTextContainer'>
              …
              <b>
                {numberFormat(content[0])} m<sup>2</sup>
              </b>
              seines Gartens
              <br /> (oder{' '}
              {(+numberFormat(content[0]) / 11.5)
                .toFixed(1)
                .replace('.', ',')}{' '}
              Parkfelder) mit Buchen bepflanzen und diese 100 Jahre wachsen
              lassen.
            </div>
          </div>

          <span className='infoButton'>
            {' '}
            <i className='info circle icon' />
            So wurde berechnet
          </span>
        </>
      )

    case 'cars':
      return (
        <>
          <div className='vizText'>
            <Image file={require('images/_illus_cars.svg')} />
            <div className='vizTextContainer'>
              {' '}
              ... <b>{numberFormat(content[0])} Wochen</b>
              <br />
              {+numberFormat(content[0]) / 52 > 1 && (
                <>
                  {' '}
                  (oder{' '}
                  {(+numberFormat(content[0]) / 52)
                    .toFixed(1)
                    .toString()
                    .replace('.', ',')}{' '}
                  Jahre)
                </>
              )}{' '}
              auf das Auto verzichten.
            </div>
          </div>
          <span className='infoButton'>
            {' '}
            <i className='info circle icon' />
            So wurde berechnet
          </span>
        </>
      )

    case 'baskets':
      return (
        <>
          <div className='vizText'>
            <Image file={require('images/_illus_baskets.svg')} />
            <div className='vizTextContainer'>
              …
              <b>
                {numberFormat(Math.round(content[0] / 1000) * 1000).replace(
                  '.',
                  ' '
                )}{' '}
                Plastiksäckli
              </b>
              <br /> einsparen.
            </div>
          </div>
          <span className='infoButton'>
            {' '}
            <i className='info circle icon' />
            So wurde berechnet
          </span>
        </>
      )

    case 'meat':
      return (
        <>
          <div className='vizText'>
            <Image file={require('images/_illus_meat.svg')} />

            <div className='vizTextContainer'>
              …<b>{numberFormat(content[0])} Monate</b>
              <br />
              (oder{' '}
              {(+numberFormat(content[0]) / 12)
                .toFixed(1)
                .toString()
                .replace('.', ',')}
              Jahre) auf den Konsum von Fleisch verzichten.
            </div>
          </div>
          <span className='infoButton'>
            {' '}
            <i className='info circle icon' />
            So wurde berechnet
          </span>
        </>
      )
    default:
      return <></>
  }
}
